export default __webpack_public_path__ + "static/kb_3_14-6fd50fb9606c82807c0395d6c5774f5c.jpg";